/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-03 17:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Page, Button } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import checkCircleIcon from 'src/assets/images/dashboard/newFeatureOnBoard/check-circle-icon.png';

class StepFour extends Component<Props> {
  render() {
    const { i18n, updateStep } = this.props;
    return (
      <div className="BC-Page PFS-New-Feature-Onboard PFS-New-Feature-Onboard--four">
        <Page>
          <div>{i18n.translate(`AdminHTML.Dashboard.NewFeatureOnboard.step04_Title`)}</div>
          <div className="feature-list">
            {[1, 2, 3, 4, 5].map(element => (
              <div className="feature-card">
                <div>
                  <img
                    src={checkCircleIcon}
                    alt={i18n.translate(
                      `AdminHTML.Dashboard.NewFeatureOnboard.step04_Label0${element}`
                    )}
                    width={32}
                  />
                </div>
                <div>
                  <p>
                    {i18n.translate(
                      `AdminHTML.Dashboard.NewFeatureOnboard.step04_Label0${element}`
                    )}
                  </p>
                  <p>
                    {i18n.translate(
                      `AdminHTML.Dashboard.NewFeatureOnboard.step04_Content0${element}`
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="divider" />
          <div className="actions">
            <div className="step-action-circle">
              {[0, 1, 2, 3, 4].map(e => (
                <div
                  className={`circle ${e === 3 ? 'circle-active' : ''}`}
                  onClick={() => updateStep(e)}
                />
              ))}
            </div>
            <div className="action-btn">
              <Button onClick={() => updateStep(2)}>
                {i18n.translate(`AdminHTML.Dashboard.NewFeatureOnboard.actionBack`)}
              </Button>
              <Button onClick={() => updateStep(4)} primary>
                {i18n.translate(`AdminHTML.Dashboard.NewFeatureOnboard.actionNext`)}
              </Button>
            </div>
          </div>
        </Page>
      </div>
    );
  }
}

export default withI18n()(StepFour);
